import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Input from '@material-ui/core/Input';
import PropTypes from 'prop-types';


const RateInfo = props => (
  <FormControl fullWidth>
    <FormLabel htmlFor="rate">Wechselkurs</FormLabel>
    <Input
      value={props.value}
      disabled
      inputProps={{
          id: 'rate',
          style: { color: 'rgba(0, 0, 0, 0.87)' },
        }}
    />

  </FormControl>
);


export default RateInfo;

RateInfo.propTypes = {
  value: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/calculator/RateInfo.js